// extracted by mini-css-extract-plugin
export default {"main":"fabb9d55e0","tit":"_958468a195","maintitle":"_0bce30adef","ylw":"_98590b9c00","white":"cb4c1aba89","mv_title":"c434fe90c1","mv_nc":"f1589cf30d","mv_in":"f9b76a8202"};